module.exports = vendor0_94bafd01;